import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { attachmentsData } from '../data';
import { IAttachmentDownloadUrlResponse, IAttachmentResponse } from '../dtos';
import { IAttachmentsApiClient } from './i-attachments-api.client';
import { ICreateAttachmentRequest } from '../dtos/requests';

@Injectable({
  providedIn: 'root'
})
export class AttachmentsInMemoryApiClient implements IAttachmentsApiClient {
  constructor(protected http: HttpClient) {}

  getById(id: string): Observable<IAttachmentDownloadUrlResponse> {
    return of(attachmentsData.attachmentDownloadUrlResponse);
  }

  getByIdDownloadUrl(id: string): Observable<IAttachmentDownloadUrlResponse> {
    return of(attachmentsData.attachmentDownloadUrlResponse);
  }

  create(request: ICreateAttachmentRequest): Observable<string> {
    return of(attachmentsData.attachmentCreateResponse);
  }
}
